import { render, staticRenderFns } from "./TechCourse.vue?vue&type=template&id=32ae1d71&scoped=true"
import script from "./TechCourse.vue?vue&type=script&lang=ts"
export * from "./TechCourse.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/course.css?vue&type=style&index=0&id=32ae1d71&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae1d71",
  null
  
)

export default component.exports